import { Box } from "rebass/styled-components";
import styled from "styled-components";
import { useState } from "react";
import { isValidCDNUrl, isVideoUrl } from "MVVM/Utilities/Clip";

interface IBannerProps {
  coverImageUrl?: string;
}

export const Banner = ({ coverImageUrl }: IBannerProps) => {
  const [videoError, setVideoError] = useState(false);

  const fallbackCoverUrl = `${process.env.REACT_APP_S3_CLIP_BUCKET}/static/profile/banner/allstar.jpg`;

  const coverUrl =
    coverImageUrl && isValidCDNUrl(coverImageUrl)
      ? coverImageUrl
      : fallbackCoverUrl;

  const isVideo = isVideoUrl(coverUrl) && !videoError;
  const handleVideoError = () => setVideoError(true);

  return (
    <BannerSection bannerImage={!isVideo ? coverUrl : ""}>
      {isVideo && (
        <>
          <BackgroundVideo
            src={coverUrl}
            autoPlay
            loop
            muted
            playsInline
            onError={handleVideoError}
          />
          <VideoOverlay />
        </>
      )}
    </BannerSection>
  );
};

const BannerSection = styled(Box)<{ bannerImage: string }>`
  background: ${({ bannerImage }) =>
    bannerImage
      ? `
    linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.4) 60%, rgba(30, 46, 58, 0.2) 80%),
    linear-gradient(180deg, rgba(30, 46, 58, 0) 40%, #1e2e3a 100%),
    url(${bannerImage}) lightgray 50% / cover no-repeat
  `
      : `
    linear-gradient(180deg, rgba(30, 46, 58, 0) 40%, #1e2e3a 100%)
  `};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  height: 117px;
  overflow: hidden;
  position: relative;
`;

const BackgroundVideo = styled.video`
  height: 117px;
  left: 0;
  object-fit: cover;
  object-position: center;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 1;
`;

const VideoOverlay = styled(Box)`
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0.4) 60%,
      rgba(30, 46, 58, 0.2) 80%
    ),
    linear-gradient(180deg, rgba(30, 46, 58, 0) 40%, #1e2e3a 100%);
  height: 117px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
`;
